"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.experimentsService = exports.ExperimentsService = void 0;
var tslib_1 = require("tslib");
var ExperimentsService = /** @class */ (function () {
    function ExperimentsService() {
    }
    ExperimentsService.prototype.isEnabled = function (experimentName) {
        var _a, _b;
        if (!this.experimentsBag) {
            console.error("Experiments Service :: isEnabled('".concat(experimentName, "') called while experiments are not conducted yet. Returning false"));
            return false;
        }
        return ((_a = this.experimentsBag) === null || _a === void 0 ? void 0 : _a[experimentName]) === 'true' || ((_b = this.experimentsBag) === null || _b === void 0 ? void 0 : _b[experimentName]) === true;
    };
    ExperimentsService.prototype.init = function (experimentsBag) {
        this.experimentsBag = tslib_1.__assign(tslib_1.__assign({}, this.experimentsBag), experimentsBag);
    };
    ExperimentsService.prototype.reset = function () {
        this.experimentsBag = null;
    };
    return ExperimentsService;
}());
exports.ExperimentsService = ExperimentsService;
exports.experimentsService = new ExperimentsService();
//# sourceMappingURL=index.js.map